import { pages } from "../../../Consts/config";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../Hooks/useAuth";
import React, { useEffect } from "react";

type RouteProtectorProps = {
  element: React.ReactElement;
  fallback?: string;
  isGuarded?: boolean;
};

const RouteProtector = ({
  element,
  fallback,
  isGuarded,
}: RouteProtectorProps): React.ReactElement => {
  const EMPTY_COMPONENT: React.ReactElement = <div />;
  const navigate = useNavigate();
  const location = useLocation();
  const { pending, isSignedIn } = useAuth();
  const renderChild = !(Boolean(isGuarded) && pending);

  useEffect(() => {
    const page = pages.urlToPage(location.pathname);
    document.title = `V2 | ${page.name}`;

    if (isGuarded && !pending && !isSignedIn) {
      navigate(fallback || "/");
    }
  }, [
    location.pathname,
    pending,
    isSignedIn,
    isGuarded,
    fallback,
    navigate,
  ]);

  return renderChild ? element : EMPTY_COMPONENT;
};

export default RouteProtector;
